import React from 'react'
// import EtCreateUserImprintPlanSelfComp from '@/features/userMagic/userImprint/EtCreateUserImprintPlanSelfComp'
import EtCreateUserImprintPlanSelfComp from '@/pages/home/web/userImprint/EtCreateUserImprintPlanSelfComp'
import {
    XCircleIcon
  } from "@heroicons/react/24/solid"

const EtModalCreateUserImprintPlanSelf = ({isOpen, userId, userOrgId, triggeringUrl, onClose}) => {

  // First Created - 14 Jan 2025
  // Author - Atul Pandey
  // Inherited from EtModalCreateUserImprintGratitude
  // Updated - 25 Aug 2025 - changed the comp from @/features to @/pages/home/web
  // console.log('triggering url', triggeringUrl)

  if (!isOpen) return null


  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-70 flex justify-center items-start font-poppins overflow-y-auto p-4">
      <div className="bg-black p-5 rounded-lg shadow-lg shadow-black relative w-full max-w-4xl">
        <div
          className="absolute top-2 right-2 m-2 font-bold rounded-full cursor-pointer h-7 w-7 flex justify-center items-center"
          onClick={onClose}
        >
          <XCircleIcon className='text-orange-600 rounded-full hover:text-red-600 h-7 w-7'/>
        </div>
        <EtCreateUserImprintPlanSelfComp userId={userId} userOrgId={userOrgId} triggeringUrl={triggeringUrl} onClose={onClose}/>
      </div>
    </div>
  )
}

export default EtModalCreateUserImprintPlanSelf